<p-checkbox
	name="sameAsBillTo"
	binary="true"
	[(ngModel)]="useBillToAddress"
	label="Same as bill to"
	(ngModelChange)="copyAddress(useBillToAddress)"
></p-checkbox>

<app-contact-info-form
	[(firstName)]="subscriptionItemService.customer.shipTo.firstName"
	[(lastName)]="subscriptionItemService.customer.shipTo.lastName"
	[(email)]="subscriptionItemService.customer.shipTo.email"
	[(phone)]="subscriptionItemService.customer.shipTo.phone"
	(addressChange)="onAddressEntry($event)"
	(formComplete)="submit()"
	buttonClass="p-button-success"
	buttonText="Next"
></app-contact-info-form>
